import * as Yup from "yup";

import { basicEntityFromJson, IBasicEntity } from "../../../core/models";
import { ITransaction, transactionFromJson } from "../../transaction/data/entities";

interface IBudgetHistoryBase {
  amountBefore: number;
  amountAfter: number;
}

export interface IBudgetHistory extends IBudgetHistoryBase, IBasicEntity {
  transaction: ITransaction;
}

export interface IBudgetHistoryForm extends IBudgetHistoryBase {}

const budgetHistoryCommonValidation = {
  amountBefore: Yup.number().required(),
  amountAfter: Yup.number().required(),
};

export const budgetHistoryFormValidation = Yup.object<IBudgetHistoryForm>({
  ...budgetHistoryCommonValidation,
});

export const budgetHistoryEditFormValidation = Yup.object<IBudgetHistoryForm>({
  ...budgetHistoryCommonValidation,
});

export const budgetHistoryFromJson = (json: any): IBudgetHistory => {
  const e: IBudgetHistory = {
    ...basicEntityFromJson(json),
    amountBefore: json.amountBefore,
    amountAfter: json.amountAfter,
    transaction: transactionFromJson(json.transaction),
  };

  return e;
};

export const budgetHistoryToJson = (form: IBudgetHistoryForm) => {
  return {
    amountBefore: form.amountBefore,
    amountAfter: form.amountAfter,
  };
};
